import ITheme from "@/interfaces/iTheme";
import backgroundImage from "@assets/themes/default/backgroundImage.svg";

export class DefaultTheme implements ITheme
{
    static Id = 'default';
    id = DefaultTheme.Id;

    name = 'Default';

    colors = {
                application: '#553A97', //#051c29
                text: '#E0E0E0',
                confirm: '#553A97',
                secondary: '#62B4E4',

                // Challenge card colors
                solved: '#455A64',
                locked: '#0009',
                unsolved: '#0E7CBC',
                noMoreAttempts: '#521414',
                disabled: '#521414',

                windowBackground: '#0009',
                windowText: '#FFF',
                windowBorder: '#FFFFFF1F',

                tag: '#62B4E4',
                activeTab: '#62B4E4',
                dialogHeader: '#553A97',
                dialogHeaderText: '#FFF',
                dialogText: '#303030',
                dialogLink: '#553A97',
                dialogSuccessText: '#4CAF50',
                dialogFailureText: '#F44336',
                dialogIcon: '#553A97',
                success: '#4CAF50',
                warning: '#FF9800',

                // Table
                tableHeaderActionButtons: 'white',
                tableHeaderSelectAllButtons: '#62B4E4',

                //settings and bulk select checkboxes 
                checkedFill: '#553A97',
                settingsInputError: '#DB4040',
                settingsInputErrorShadow: '#050C13',

                // focus indicators
                focusVisibleIndicator:  '#553A97',

                // the most common color from the background image with sufficient contrast
                backgroundImageColor: '#0A1F2F',

                actionButtonBackground: '#0A1F2F',
                actionButtonText: 'white',
             };
        
    fontFamily = "IBM Plex Mono";
    landingFontFamily = "space_frigate";
    backgroundImage = backgroundImage;
    isDark = true;
}
